import leadsmIcon from 'assets/images/account-page/lead-auto-sm-img.svg';
import classNames from "classnames";
import * as moment from 'moment';
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import currencyFormat from 'utils/currency/numberToPrice';
import numberFormat from 'utils/number/format';
import downFullArrow from '../../../assets/images/account-page/down-full-arrow.svg';
import { downgradeSubscribeLeadAutomator, selectBillingDashboard, selectCardList, selectLeadAutomator, selectPlanDetails, selectUserId, trialLeadAutomator, unSubscribeLeadAutomator, upgradeSubscribeLeadAutomator } from "../../../data/user";
import CreditCardDropdown from "../components/CreditCardDropdown";
import css from '../style.scss';
import CVV99Modal from "../components/cvv99Modal";
import LeaveMessagePopup from '../modals/LeaveMessage';

const ManageLeadAutomatorScreen = (props) => {


  const { type } = props.match.params;
  const [screenType, setscreenType] = useState(type);
  const [showCVVModal, setShowCVVModal] = useState(false);
  const userId = useSelector(selectUserId);
  const dispatch = useDispatch();
  const leadAutomatorInfo = useSelector(selectLeadAutomator)?.toJS();
  
  const cardList = useSelector(selectCardList);
  const billingInfo = useSelector(selectBillingDashboard)
  
  const planDetails = useSelector(selectPlanDetails)?.toJS();

  const [successful, setSuccessful] = useState(false); // Default selected plan
  const [selectedCard, setSelectedCard] = useState(cardList[0] || {}); // Default selected card

  const handleCardChange = (selectedOption) => {
    setSelectedCard(selectedOption);
  };
  
  const goToManageleadAutomator = () => {
    props.history.push(`/accountnew/leadautomator`);
  }

  // const goToManageLeadAutomator = (type) => {
  //   props.history.push(`/accountnew/manageleadautomator/${type}`);
  // };

  const goToAccount = () => {
    props.history.push(`/accountnew/landing`);
  }
  
  const updateLeadAutomator = async ({ cardCode = "" }) => {
    setSuccessful(false);
    const upgradePayload = {
      userId,
      planMrcId: leadAutomatorInfo?.selectedLead?.id,
      purchasePaymentMethodId: selectedCard?.paymentMethodId,
      proratedAmount: leadAutomatorInfo?.selectedLead?.prorateAmount || leadAutomatorInfo?.selectedLead?.amount,
    };
    const currentPlanMrcId = leadAutomatorInfo?.planMrcs?.find((item) => item?.quantity === leadAutomatorInfo?.monitoredProperties)?.id;
    const downgradePayload = {
      userId,
      currentPlanMrcId,
      downgradePlanMrcId: leadAutomatorInfo?.selectedLead?.id,
      planMrcId: currentPlanMrcId,
      approvedAmount: leadAutomatorInfo?.selectedLead?.amount,
    };
    const unsubscribePayload = {
      userId,
      planMrcId: currentPlanMrcId,
    };
    const trialAutomatorPayload = {
      userId,
      planMrcId: leadAutomatorInfo?.selectedLead?.id,
    };
    
    if (Number(leadAutomatorInfo?.selectedLead?.amount) && !cardCode) {
      setShowCVVModal(true);
      return;
    }
    try {
      let response;
      if (!planDetails?.usedLATrial && !planDetails?.trialAvailable) {
        if (cardCode) {
          trialAutomatorPayload.cardCode = cardCode;
        }
        response = await trialLeadAutomator(trialAutomatorPayload);
      } else if (leadAutomatorInfo?.selectedLead?.quantity > leadAutomatorInfo?.monitoredProperties) {
        if (cardCode) {
          upgradePayload.cardCode = cardCode;
        }
        response = await upgradeSubscribeLeadAutomator(upgradePayload);
      } else if (leadAutomatorInfo?.selectedLead?.quantity < leadAutomatorInfo?.monitoredProperties) {
        if (cardCode) {
          downgradePayload.cardCode = cardCode;
        }
        response = await downgradeSubscribeLeadAutomator(downgradePayload);
      } else if (!leadAutomatorInfo?.selectedLead) {
        if (cardCode) {
          unsubscribePayload.cardCode = cardCode;
        }
        response = await unSubscribeLeadAutomator(unsubscribePayload);
      } 
      if (response.success) {
        console.log("Update lead automator success:", response);
        setShowCVVModal(false);
        setSuccessful(true);
      } else {
        console.error(`Update lead automator failed:`, response.error);
        setShowCVVModal(false);
        dispatch(LeaveMessagePopup.open({
          title: "Error",
          message: response.error,
          yesLable: "Ok",
          cancelLable: null,
          CancelRedirect: () => null,
          yesRedirect: () => null
        }))
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      setShowCVVModal(false);
      dispatch(LeaveMessagePopup.open({
        title: "Error",
        message: response.error,
        yesLable: "Ok",
        cancelLable: null,
        CancelRedirect: () => null,
        yesRedirect: () => null
      }))
    }
  }
  

  return (
    <>
      <div className={css.clsInnerMainBody}>
        <div>
           <div className="container">
            <div className={css.clsLAReviewPaySec}>
              <div className="row justify-content-center" style={{"padding-bottom": '13rem'}}>
                <div className="col-lg-4">
                 
                  <FromToSelectedTier 
                    fromtype="MONITORED PROPERTIES"
                    fromAmount={leadAutomatorInfo?.monitoredProperties}
                    totype="MONITORED PROPERTIES"
                    toAmount={leadAutomatorInfo?.selectedLead?.quantity}
                  />

                </div>
                {!successful ? (
                  <div className="col-lg-5">
                    {screenType === 'unsubscribe' ? (<ReviewConfirmUnsubscribe />) : (
                       <div className={css.clsLAReviewPayCard2}>
                       <h3 className={css.clsLAReviewHeading}>Review And Confirm Changes</h3>
                       <div className={css.clsLAReviewPayTimelineContainer}>
                         <div className={css.clsLAReviewPayTimeline}>
                           <div className={css.clsLATimelineItem}>
                             <div className={css.clsLATimelineDot}></div>
                             <div className={css.clsLATimelineContent}>
                               <div className={css.clsLATimelineHead}>
                                 <h4 className={css.clsLATimelineLabel}>Due {leadAutomatorInfo?.trial14LA ? moment().add(14, 'days').format('MMMM D, YYYY') : ' Today'}</h4>
                                 <h5 className={css.clsLATimelinePrice}>
                                  {currencyFormat(leadAutomatorInfo?.selectedLead?.prorateAmount)}</h5>
                               </div>
                               <p className={css.clsLATimelineDescription}>Lead Automator plan begins {leadAutomatorInfo?.trial14LA ? ' today' : ''}</p>
                             </div>
                           </div>
   
                           <div className={css.clsLATimelineLine}></div>
   
                           <div className={css.clsLATimelineItem}>
                             <div className={css.clsLATimelineDot}></div>
                             <div className={css.clsLATimelineContent}>
                               <div className={css.clsLATimelineHead}>
                                 <h4 className={css.clsLATimelineLabel}>Starting {billingInfo ? moment.utc(billingInfo?.mainSubscriptionRenews).format('MMMM D, YYYY') : ''}</h4>
                                 <h5 className={css.clsLATimelinePrice}>{currencyFormat(leadAutomatorInfo?.selectedLead?.amount)}/month</h5>
                               </div>
                             </div>
                           </div>  
                         </div>
                       </div>
   
                       <div className={css.pb_48}>
                         <div className={css.clsLAReviewPMCard}>
                           <h4 className={css.clsLAReviewPMCardHeading}>Payment Method</h4>
                           <CreditCardDropdown
                              tag={false}
                              options={cardList}
                              paymentMethodType={'Subscription'}
                              onChange={(selectedOption) => handleCardChange(selectedOption)}
                            />
                         </div>
                       </div>
   
                       <div className={css.clsLAReviewContentPara}>
                         <p className={classNames(css.clsPara, css.mb_16)}>
                           <span className={css.text_b}>Starting on {billingInfo ? moment.utc(billingInfo?.mainSubscriptionRenews).format('MMMM D, YYYY') : ''} you’ll be charged {currencyFormat(leadAutomatorInfo?.selectedLead?.amount)} automatically every month until you cancel.</span> This does not include any other PropStream services you may be subscribed to. Your price may change as described in the <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}>PropStream Terms and Conditions.</a>
                         </p>
                         <p className={css.clsPara}>
                           By clicking “Confirm Changes” you agree to the <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}>PropStream Terms and Conditions.</a>
                         </p>
                       </div>
                     </div>
                    )}
                 
                </div>
                ) : (<SuccessfulFlow  selectedLead={leadAutomatorInfo?.selectedLead} />)}
                

              </div>
            </div>
          </div>    
        </div>

        <div className={css.clsInnerFooter}>

        {!successful ? (
          <>
           <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnPrimaryGreen)} onClick={() => goToManageleadAutomator()}> Back to Tiers </button>
           <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} onClick={updateLeadAutomator}> Confirm Changes</button>
          </>
        ) : (
          <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} onClick={() =>goToAccount()}> Return to Account Home</button>
        )}
        </div>
        {showCVVModal && <CVV99Modal
          showCVVModal={showCVVModal} cardEnding={selectedCard?.cardEnding} cvvLength={selectedCard?.cardCVVLength} handleSubmitCVV={updateLeadAutomator} 
          handleCancel={() => setShowCVVModal(false)} handleClose={() => setShowCVVModal(false)}  />}
      </div> 
    </>
  );
};



const FromToSelectedTier = (props) => {
  return (
    <div className={css.clsLAReviewPayCard}>
    <div className={css.clsLAReviewLeadAutoDetils}>
      <div className="d-flex align-items-center">
        <div className={css.clsLAReviewLeadAutoImgSmall}>
          <img src={leadsmIcon} alt="leadsmIcon" />
        </div>
        <h5 className={css.clsLAReviewLeadAutomatorTxt}>Lead Automator</h5>
      </div>
    </div>
    <div className={css.clsLAReviewTier}>
      <h4 className={css.clsTxtLine1}>{props?.fromtype}</h4>
      <h4 className={css.clsTxtLine2}>{props?.fromAmount > 0 ? numberFormat(props?.fromAmount) : 'NONE'}</h4>
    </div>
    <div className="text-center">
      <ReactSVG src={downFullArrow} className={classNames(css.mb_16, css.mt_16)} />
    </div>
    <div className={css.clsLAReviewTier}>
      <h4 className={css.clsTxtLine1}>{props?.totype}</h4>
      <h4 className={css.clsTxtLine2}>{props?.toAmount > 0 ? numberFormat(props?.toAmount) : 'NONE'}</h4>
    </div>
  </div>
  )
}

const ReviewConfirmUnsubscribe = (props) => {
  const billingInfo = useSelector(selectBillingDashboard);
  return (
    <div className={css.clsLAReviewPayCard2}>
    <h3 className={css.clsLAReviewHeading}>Review And Confirm Changes</h3>
    <div className={css.clsLAReviewPayTimelineContainer}>
      <div className={css.clsLAReviewPayTimeline}>
        <div className={css.clsLATimelineItem}>
          <div className={css.clsLATimelineDot}></div>
          <div className={css.clsLATimelineContent}>
            <div className={css.clsLATimelineHead}>
              <h4 className={css.clsLATimelineLabel}>Today</h4>
            </div>
            <p className={css.clsLATimelineDescription}>7 days remaining in your Lead Automator plan</p>
          </div>
        </div>

        <div className={css.clsLATimelineLine2}></div>

        <div className={css.clsLATimelineItem}>
          <div className={css.clsLATimelineDot}></div>
          <div className={css.clsLATimelineContent}>
            <div className={css.clsLATimelineHead}>
              <h4 className={css.clsLATimelineLabel}>Starting {billingInfo ? moment.utc(billingInfo?.mainSubscriptionRenews).format('MMMM D, YYYY') : ''}</h4>
            </div>
            <p className={css.clsLATimelineDescription}>Access to Lead Automator features ends. Resubscribe to Lead Automator at any time to regain access to Lead Automator features.</p>
          </div>
        </div> 
      </div>
    </div>

  

    <div className={css.clsLAReviewContentPara}>
      
      <p className={css.clsPara}>
        By clicking “Confirm Changes” you agree to the <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}>PropStream Terms and Conditions.</a>
      </p>
    </div>
  </div>
  )
}


const SuccessfulFlow = ({ selectedLead }) => {
  const leadAutomatorInfo = useSelector(selectLeadAutomator)?.toJS();
  const billingInfo = useSelector(selectBillingDashboard);
  
  return (
    <div className="col-lg-5">
    <div className={css.clsLAReviewPayCard2}>
      <h3 className={css.clsLAReviewHeading}>Changes Successful</h3>
      <div className={css.clsLAReviewPayTimelineContainer}>
        <div className={css.clsLAReviewPayTimeline}>
          <div className={css.clsLATimelineItem}>
            <div className={css.clsLATimelineDot}></div>
            <div className={css.clsLATimelineContent}>
              <div className={css.clsLATimelineHead}>
                <h4 className={css.clsLATimelineLabel}>{leadAutomatorInfo?.trial14LA ? `Due ${moment().add(14, 'days').format('MMMM D, YYYY')}` : 'Paid Today'}</h4>
                <h5 className={css.clsLATimelinePrice}>{currencyFormat(selectedLead?.prorateAmount)}</h5>
              </div>
              <p className={css.clsLATimelineDescription}>Lead Automator plan begins {leadAutomatorInfo?.trial14LA ? ' today' : ''}</p>
            </div>
          </div>

          <div className={css.clsLATimelineLine}></div>

          <div className={css.clsLATimelineItem}>
            <div className={css.clsLATimelineDot}></div>
            <div className={css.clsLATimelineContent}>
              <div className={css.clsLATimelineHead}>
                <h4 className={css.clsLATimelineLabel}>Starting {billingInfo ? moment.utc(billingInfo?.mainSubscriptionRenews).format('MMMM D, YYYY') : ''}</h4>
                <h5 className={css.clsLATimelinePrice}>{currencyFormat(selectedLead?.amount)}/month</h5>
              </div>
            </div>
          </div>  
        </div>
      </div>

    
    </div>
  </div>
  )
}


export default withRouter(ManageLeadAutomatorScreen);
